/* Veinly 3D & motion system, progressive enhancement only.
   Everything here is optional: floating books, glow orbs and the base
   fade-in state are all correct without this file (see veinly-motion-3d.css
   and the .veinly-reveal--no-js fallback below). */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function initScrollReveal() {
    var targets = document.querySelectorAll('.veinly-reveal');
    if (!targets.length) return;

    if (reduceMotion.matches || typeof IntersectionObserver === 'undefined') {
      targets.forEach(function (el) {
        el.classList.add('veinly-reveal--no-js');
      });
      return;
    }

    var show = function (el) {
      el.classList.add('veinly-reveal--visible');
    };

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          /* A block taller than the screen (e.g. a long card grid on a phone)
             can never reach 15% visible, so also reveal once a good slice of
             the screen is covered by it. */
          var coversScreen = entry.intersectionRect.height >= window.innerHeight * 0.3;
          if (entry.intersectionRatio >= 0.15 || coversScreen) {
            show(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: [0, 0.05, 0.15, 0.3] }
    );

    targets.forEach(function (el) {
      /* Very tall blocks would otherwise stay invisible on small screens. */
      if (el.offsetHeight * 0.15 > window.innerHeight * 0.8) {
        show(el);
        return;
      }
      observer.observe(el);
    });
  }

  function initMouseParallax() {
    if (isTouch || reduceMotion.matches) return;
    if (!document.body.classList.contains('veinly-parallax-on')) return;

    var heroes = document.querySelectorAll('[data-veinly-parallax]');
    if (!heroes.length) return;

    heroes.forEach(function (hero) {
      var books = hero.querySelectorAll('.veinly-book__tilt');
      if (!books.length) return;

      var raf = null;

      hero.addEventListener('mousemove', function (event) {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          var rect = hero.getBoundingClientRect();
          var relX = (event.clientX - rect.left) / rect.width - 0.5;
          var relY = (event.clientY - rect.top) / rect.height - 0.5;

          books.forEach(function (book) {
            var strength = parseFloat(book.getAttribute('data-parallax-strength') || '6');
            var baseY = parseFloat(book.style.getPropertyValue('--book-tilt-y') || '0');
            var baseZ = parseFloat(book.style.getPropertyValue('--book-tilt-z') || '0');
            book.style.setProperty('--book-tilt-y', baseY + relX * strength + 'deg');
            book.style.setProperty('--book-tilt-z', baseZ - relY * (strength / 2) + 'deg');
          });

          raf = null;
        });
      });

      hero.addEventListener('mouseleave', function () {
        books.forEach(function (book) {
          book.style.removeProperty('--book-tilt-y');
          book.style.removeProperty('--book-tilt-z');
        });
      });
    });
  }

  function initProductGallery() {
    var galleries = document.querySelectorAll('[data-veinly-gallery]');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var img = gallery.querySelector('[data-veinly-book-img]');
      var bookEl = gallery.querySelector('.veinly-book');
      if (!img) return;

      var thumbWrap = gallery.parentElement.querySelector('.veinly-p-hero__thumbs');
      if (!thumbWrap) return;

      var thumbs = thumbWrap.querySelectorAll('[data-veinly-thumb]');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (thumb.classList.contains('is-active')) return;

          thumbs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-pressed', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');

          var swap = function () {
            img.src = thumb.getAttribute('data-full');
            img.srcset = thumb.getAttribute('data-srcset');
            img.alt = thumb.getAttribute('data-alt') || img.alt;
            if (bookEl) bookEl.classList.remove('is-swapping');
          };

          if (bookEl && !reduceMotion.matches) {
            bookEl.classList.add('is-swapping');
            window.setTimeout(swap, 180);
          } else {
            swap();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollReveal();
      initMouseParallax();
      initProductGallery();
    });
  } else {
    initScrollReveal();
    initMouseParallax();
    initProductGallery();
  }
})();
